import React, { useState } from "react";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import ContentLayoutFooterNoChartreuse from "../components/Layout/ContentLayoutFooterNoChartreuse";

interface FAQItemProps {
  question: string;
  answer: string;
  category: string;
}

const FAQItem: React.FC<FAQItemProps> = ({ question, answer }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <li className="border-b border-gray-300 py-4">
      <h2 className="flex justify-between items-center text-xl">
        {question}
        {isExpanded ? (
          <KeyboardArrowDownIcon
            className="cursor-pointer text-gray-400 ml-2"
            onClick={toggleExpanded}
          />
        ) : (
          <KeyboardArrowUpIcon
            className="cursor-pointer text-gray-400 ml-2"
            onClick={toggleExpanded}
          />
        )}
      </h2>
      {isExpanded && <p className="text-gray-500 text-sm mt-2">{answer}</p>}
    </li>
  );
};

const ShippingExchanges = () => {
  const faqItems: FAQItemProps[] = [
    {
      question: "When will my new artwork arrive from Raraity?",
      answer:
        "We strive to provide fast and efficient shipping for all of our customers. Unframed works typically ship within 2-3 business days, and framed works will usually ship within 5-7 business days. As soon as your piece has shipped, you will receive a tracking number to stay updated on its delivery status.",
      category: "Shipping",
    },
    {
      question:
        "Can I change the shipping address for my recent Raraity order?",
      answer:
        "Unfortunately, we are unable to redirect orders once they have been dispatched. Therefore, we ask that you ensure the correct shipping address is entered at the time of order to avoid any issues with delivery.",
      category: "Shipping",
    },
    {
      question: "Does Raraity offer international shipping for its wall art?",
      answer:
        "Raraity does not currently ship internationally through our website. If you are outside the United States and are still interested in collecting from Raraity, please reach out to hi@raraity.com with any specific requests and we will invoice you manually.",
      category: "Shipping",
    },
    {
      question: "What is Raraity's return policy for its wall art?",
      answer:
        "We take pride in providing accurate descriptions and visuals of our wall art to ensure customer satisfaction. However, if you are displeased with your acquisition, please email us at hi@raraity.com.",
      category: "Shipping",
    },
  ];

  const groupedFaqItems: Record<string, FAQItemProps[]> = {};
  faqItems.forEach((item) => {
    if (!groupedFaqItems[item.category]) {
      groupedFaqItems[item.category] = [];
    }
    groupedFaqItems[item.category].push(item);
  });

  return (
    <ContentLayoutFooterNoChartreuse title="Shipping & Exchanges">
      <div className="container m-auto p-4">
        <h1 className="text-xl mb-8">Frequently Asked Questions</h1>
        {Object.entries(groupedFaqItems).map(([category, items]) => (
          <div key={category} className="mb-8">
            {/* <h3 className="text-l mb-4">{category}</h3> */}
            <ul>
              {items.map((item) => (
                <FAQItem
                  key={item.question}
                  question={item.question}
                  answer={item.answer}
                  category={item.category}
                />
              ))}
            </ul>
          </div>
        ))}
      </div>
    </ContentLayoutFooterNoChartreuse>
  );
};

export default ShippingExchanges;

export async function getStaticProps() {
  return {
    props: { page: "Shipping-Exchanges" },
  };
}
